import { useEffect, useRef } from "react";

const ArticleAds = () => {
  const adRef = useRef(null);

  useEffect(() => {
    if (adRef.current && !adRef.current.dataset.loaded) {
      try {
        (window.adsbygoogle = window.adsbygoogle || []).push({});
        adRef.current.dataset.loaded = "true";
      } catch (e) {
        console.error(e);
      }
    }
  }, []);

  return (
    <ins
      ref={adRef}
      className="adsbygoogle"
      style={{
        display: "block",
        textAlign: "center",
      }}
      data-ad-layout="in-article"
      data-ad-format="fluid"
      data-ad-client="ca-pub-5162535306990850"
      data-ad-slot="2324830876"
    />
  );
};

export default ArticleAds;